/**
 * @file http.service.ts
 * @module to make http request
 * @author Nagendra
 */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LocalstorageService } from '../localstorage/localstorage.service';

@Injectable()
export class HttpService {
  id: any;
  testUrl: string = environment.mcqTestUrl;
  constructor(private http: HttpClient, private localservice: LocalstorageService, public router: Router) { }
  public baseUrl: string = environment.mcqTestUrl + "";
  public userbaseUrl:string=environment.userServiceUrl + "";
  newResponse;
  public redirectTo(moduleName: string, route?: string): void {
    let routeArray = [moduleName];
    if (route) {
      routeArray.push(route);
    }
    this.router.navigate(routeArray);
  };
  /**function to respond for post call */
  public httpPost(option: any, isAuthRequired: boolean): Observable<{}> {
  //  console.log("option", this.localservice.getData('token'));
    var httpAuthOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    if (isAuthRequired) {
      httpAuthOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': this.localservice.getData('token')
        })
      };
    }

    

    option.url = this.baseUrl + option.url;
    //console.log(option);
    return this.http.post(option.url, option.body, httpAuthOptions)
  }
  public httpPostWithTokens(option: any, isAuthRequired: boolean){
   // console.log("option", this.localservice.getData('token'));
    var httpAuthOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    if (isAuthRequired) {
      httpAuthOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': this.localservice.getData('testTokens')
        })
      };
    }

    option.url = this.baseUrl + option.url;
    //console.log(option);
    return this.http.post(option.url, option.body, httpAuthOptions)
  }

  public putWithTokens(option: any, isAuthRequired: boolean): Observable<{}> {
    //console.log("option", this.localservice.getData('token'));
    var httpAuthOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    if (isAuthRequired) {
      httpAuthOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': this.localservice.getData('token')
        })
      };
    }

    

    option.url = this.userbaseUrl + option.url;
   // console.log(option);
    return this.http.post(option.url, option.body, httpAuthOptions)
  }

  postWithParams(option: any, isAuthRequired: boolean){
    //console.log("option in here", this.localservice.getData('token'));
    //console.log("id", localStorage.getItem('testid') );
    this.id = this.localservice.getData('testid');
    var httpAuthOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    if (isAuthRequired) {
      httpAuthOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': this.localservice.getData('token')
        })
      };
    }
    option.url = this.baseUrl + option.url;
    //console.log(option);
    return this.http.post(option.url + "?testId="+this.id, option.body ,  httpAuthOptions)
  }
  /**function to respond for put call */
  public httpPut(option: any): Observable<{}> {
    //console.log("option", option);

    var httpAuthOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': this.localservice.getData('token')
      })
    };
    option.url = this.baseUrl + option.url;
    return this.http.put(option.url, option.body, httpAuthOptions)
  }

  /**function to respond for get call and return required data*/
  public httpGet(option: any): Observable<any> {
    //console.log("option", option);

    var httpAuthOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': this.localservice.getData('token')
      })
    };
    option.url = this.baseUrl + option.url;
    return this.http.get(option.url, httpAuthOptions)
  }

  public httpGetWithoutAuth(option: any): Observable<any> {
    //console.log("option", option);

    var httpAuthOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    //console.log("Baseurl", this.baseUrl);
    option.url = this.baseUrl + option.url;
    return this.http.get(option.url, httpAuthOptions)
  }

  setResponse(response: any){
    //console.log("SetResponse");
    this.newResponse = response;
  }
  getResponse() {
    //console.log("getResponse" , this.newResponse);
    return this.newResponse;
  }

  getWithTokens(options){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('token')
    });

    return this.http.get(this.testUrl + options.purpose , {headers});
  }

  //   /**function to respond for post call */
  //   public httpUploadPost(option: any): Observable<{} > {
  //   let otherOption: any = {
  //     responseType: "json"
  //   };

  //   option.url = this.baseUrl + option.url;
  //   return this.http.post(option.url, option.body, otherOption)
  // }
}
